import { api } from './client.js';

const root = '/admin/analytics';

export const analyticsApi = {
  overview: (params) => api.get(`${root}/overview`, { query: params }),
  storeReport: (id, params) => api.get(`${root}/stores/${id}`, { query: params }),
  employeeReport: (id, params) => api.get(`${root}/employees/${id}`, { query: params }),
  topProducts: (params) => api.get(`${root}/products/top`, { query: params }),
  aiCost: (params) => api.get(`${root}/ai-cost`, { query: params })
};
